<h2 mat-dialog-title>
    Détails d'éligibilité technique {{ technicalEligibilityApiService.getTechnologyDisplayedName(data.technology) }} @if (data.siteName) { - Site "{{ data.siteName }}" }
    <button matIconButton [cdkCopyToClipboard]="data.eligibilityAppUuid"><mat-icon matTooltip="Eligibility request UUID: {{ data.eligibilityAppUuid }}">info</mat-icon></button>
</h2>

<mat-dialog-content>
    <ag-grid-angular
        class="p-4"
        style="width: 100%; height: 100%;"
        [columnDefs]="COLUMN_DEFS"
        [localeText]="gridLocale"
        [rowData]="rowData()"
        [pagination]="false"
        [domLayout]="'autoHeight'"
        [autoSizeStrategy]="{type: 'fitGridWidth'}"
        [animateRows]="false"
        [rowClassRules]="rowClassRules"
        />
</mat-dialog-content>